import { featureEnabler, isLogoWidget } from '@kaltura-ott/tvpil-shared';

import { FEATURES } from 'consts';

export function checkIsLogoRailV2(categoryTree: any) {
  const isEnabledLogoRail = !featureEnabler.variation(FEATURES.DISABLE_NEW_LOGO_WIDGET, false);

  return isLogoWidget(categoryTree) && isEnabledLogoRail;
}
